import Vue from 'vue'
import Router from 'vue-router'

import Storage from '@/helpers/storage'

import Auth from '@/modules/auth'
import Providers from '@/modules/providers'

import AddInbox from '@/views/AddInbox.vue'
import ConsentPage from '@/views/ConsentPage.vue'
import Fetch from '@/views/Fetch.vue'
import Landing from '@/views/Landing/Landing'
import LoginEmail from '@/views/LoginEmail.vue'
import LoginPage from '@/views/LoginPage.vue'
import LoginProvider from '@/views/LoginProvider.vue'
import LoginProviderV2 from '@/views/LoginProviderV2.vue'
import MagicLinkPre from '@/views/MagicLinkPre.vue'
import MagicLinkPost from '@/views/MagicLinkPost.vue'
import MicrosoftLoading from '@/views/MicrosoftLoading.vue'
import MyActions from '@/views/MyActions.vue'
import Newsletters from '@/views/Newsletters.vue'
import Partner from '@/views/Partner.vue'
import SaveThePlanet from '@/views/SaveThePlanet.vue'
import Settings from '@/views/Settings.vue'
import Stats from '@/views/Stats.vue'
import UpdateApp from '@/views/UpdateApp.vue'
import UserForm from '@/views/UserForm.vue'
import WeForest from '@/views/WeForest.vue'

import About from '@/views/About.vue'
import CookiesPolicy from '@/views/CookiesPolicy.vue'
import Faq from '@/views/Faq.vue'
import Foxintelligence from '@/views/Foxintelligence.vue'
import Impressum from '@/views/Impressum.vue'
import MyData from '@/views/MyData.vue'
import Press from '@/views/Press.vue'
import Privacy from '@/views/Privacy.vue'
import Terms from '@/views/Terms.vue'


Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: `/${Storage.getItem('lang')}`,
    routes: [
        {
            path: '/',
            name: 'landing',
            component: Landing,
            beforeEnter: Auth.checkNotAuth
        },
        {
            path: '/consent-page',
            name: 'consent-page',
            component: ConsentPage
        },
        //microsoft
        {
            path: '/login/microsoft/success',
            redirect: '/connect/microsoft'
        },
        {
            path: '/login/microsoft/error',
            redirect: '/connect/microsoft'
        },
        {
            path: '/connect/microsoft',
            name: 'microsoft-loading',
            component: MicrosoftLoading
        },
        {
            path: '/login/microsoft',
            component: UpdateApp
        },
        // end microsoft
        {
            path: '/login',
            name: 'login',
            component: LoginPage,
            beforeEnter: loginRules
        },
        {
            path: '/login/email',
            name: 'login-email',
            component: LoginEmail
        },
        {
            path: '/login/google',
            name: 'login-google',
            component: LoginProviderV2,
            beforeEnter: loginRules
        },
        {
            path: '/login/:provider',
            name: 'login-provider',
            component: LoginProvider,
            beforeEnter: loginRules
        },
        {
            path: '/magic-request-email',
            name: 'magic-request',
            component: MagicLinkPre
        },
        {
            path: '/magic-link',
            name: 'magic-link',
            component: MagicLinkPost
        },
        {
            path: '/auth-link',
            name: 'auth-link',
            component: MagicLinkPost
        },
        {
            path: '/user-form',
            name: 'user-form',
            component: UserForm,
            beforeEnter: Auth.checkAuth
        },
        {
            path: '/newsletters',
            name: 'newsletters',
            component: Newsletters,
            beforeEnter: Auth.checkAuth
        },
        {
            path: '/my-actions',
            name: 'my-actions',
            component: MyActions,
            beforeEnter: Auth.checkAuth
        },
        {
            path: '/fetch',
            name: 'fetch',
            component: Fetch,
            beforeEnter: Auth.checkAuth
        },
        {
            path: '/add-inbox',
            name: 'add-inbox',
            component: AddInbox,
            beforeEnter: Auth.checkAuth
        },
        {
            path: '/settings',
            name: 'settings',
            component: Settings,
            beforeEnter: Auth.checkAuth
        },
        {
            path: '/stats',
            name: 'stats',
            component: Stats,
            beforeEnter: Auth.checkAuth
        },
        {
            path: '/weforest',
            name: 'weforest',
            component: WeForest,
            beforeEnter: Auth.checkAuth
        },
        // PARTNERS
        {
            path: '/partner/:name',
            name: 'partner',
            component: Partner
        },
        // STATIC REDIRECT
        {
            path: '/about',
            redirect: '/fox/about'
        },
        {
            path: '/cookies-policy',
            redirect: '/fox/cookies-policy'
        },
        {
            path: '/foxintelligence',
            redirect: '/fox/foxintelligence'
        },
        {
            path: '/my-data',
            redirect: '/fox/my-data'
        },
        {
            path: '/press',
            redirect: '/fox/press'
        },
        {
            path: '/privacy',
            redirect: '/fox/privacy'
        },
        {
            path: '/terms',
            redirect: '/fox/terms'
        },
        {
            path: '/faq',
            redirect: '/fox/faq'
        },
        {
            path: '/impressum',
            redirect: '/fox/impressum'
        },
        // STATIC FOX
        {
            path: '/fox/about',
            name: 'about',
            component: About
        },
        {
            path: '/fox/cookies-policy',
            name: 'cookies-policy',
            component: CookiesPolicy
        },
        {
            path: '/fox/foxintelligence',
            name: 'foxintelligence',
            component: Foxintelligence
        },
        {
            path: '/fox/my-data',
            name: 'my-data',
            component: MyData
        },
        {
            path: '/fox/press',
            name: 'press',
            component: Press
        },
        {
            path: '/fox/privacy',
            name: 'privacy',
            component: Privacy,
            beforeEnter: getToken
        },
        {
            path: '/fox/terms',
            name: 'terms',
            component: Terms
        },
        {
            path: '/fox/faq',
            name: 'faq',
            component: Faq
        },
        {
            path: '/fox/impressum',
            name: 'impressum',
            component: Impressum
        },
        // STATIC FOX NATIVE
        {
            path: '/fox/native/about',
            component: About
        },
        {
            path: '/fox/native/cookies-policy',
            component: CookiesPolicy
        },
        {
            path: '/fox/native/foxintelligence',
            component: Foxintelligence
        },
        {
            path: '/fox/native/my-data',
            component: MyData
        },
        {
            path: '/fox/native/press',
            component: Press
        },
        {
            path: '/fox/native/privacy',
            component: Privacy,
            beforeEnter: getToken
        },
        {
            path: '/fox/native/terms',
            component: Terms
        },
        {
            path: '/fox/native/faq',
            component: Faq
        },
        {
            path: '/fox/native/impressum',
            component: Impressum
        },
        {
            path: '/:lang/fox/native/:page',
            component: Impressum,
            beforeEnter: youShallNotPass
        },
        {
            path: '/save-the-planet',
            name: 'save-the-planet',
            component: SaveThePlanet
        },

        // deeplinks
        {
            path: '/addInbox-link',
            redirect: '/add-inbox'
        },
        {
            path: '/stats-link',
            redirect: '/stats'
        },
        {
            path: '/referral-link',
            redirect: '/weforest'
        },
        {
            path: '/card-link',
            redirect: '/newsletters'
        },
        {
            path: '/stories-link',
            redirect: () => ({
                path: '/stats',
                query: { forceStories: true }
            })
        },
        {
            path: '/reconnect-link',
            redirect: '/add-inbox'
        },
        {
            path: '/panel-link',
            redirect: () => ({
                path: '/settings',
                query: { forcePanel: true }
            })
        },
        {
            path: '/privacy-link',
            redirect: '/privacy'
        },
        {
            path: '/mydata-link',
            redirect: '/my-data'
        },
        {
            path: '/notif-link',
            redirect: () => ({
                path: '/settings',
                query: { forceNotif: true }
            })
        },

        // others
        {
            path: '/*',
            redirect: '/'
        }
    ]
})

export default router

function loginRules(to, from, next) {

    const provider = to.path.substring(7)

    if (!Storage.getItem('token') && from.path !== '/consent-page') {

        next({path: '/consent-page', query: {provider: provider}})

    } else {

        const isSpecificProvider = Providers.isSpecificProvider(provider)

        if (to.path === `/login/${provider}` && isSpecificProvider) {
            next()
        } else if (to.path === '/login' && isSpecificProvider) {

            next({path: `/login/${provider}`, params: {provider: provider}})

        } else if (to.path !== '/login') {

            next({path: '/login'})
        } else {

            next()
        }
    }
}

function getToken(to, from, next) {

    if (to.query.token) {
        Storage.setItem('token', to.query.token)
    }
    next()

}

function youShallNotPass(to, from, next) {
    // if static page exist but lang doesn't exist yet, redirect to EN existing page

    const page = to.params.page

    if (['about', 'cookies-policy', 'foxintelligence', 'my-data', 'press', 'privacy', 'terms', 'faq', 'impressum'].indexOf(page) > -1) {

        next({path: `/fox/native/${page}`})

    } else {

        next('/')

    }


}
